var map = {
	"./assets/icons/agriculture.svg": 3436,
	"./assets/icons/analyzesicon_leaves.svg": 4584,
	"./assets/icons/analyzesicon_product.svg": 6664,
	"./assets/icons/analyzesicon_soil.svg": 7139,
	"./assets/icons/analyzesicon_water.svg": 7933,
	"./assets/icons/arrowdown.svg": 4250,
	"./assets/icons/arrowright.svg": 9672,
	"./assets/icons/arrowup.svg": 8136,
	"./assets/icons/backspace.svg": 2089,
	"./assets/icons/badobject.svg": 9011,
	"./assets/icons/bulb.svg": 5713,
	"./assets/icons/buy.svg": 3198,
	"./assets/icons/calendar.svg": 2047,
	"./assets/icons/cancel.svg": 2280,
	"./assets/icons/chevrondown.svg": 1656,
	"./assets/icons/chevronleft.svg": 2992,
	"./assets/icons/chevronright.svg": 9468,
	"./assets/icons/chevronup.svg": 5750,
	"./assets/icons/contactaddress.svg": 3246,
	"./assets/icons/contactfacebook.svg": 4955,
	"./assets/icons/contactinstagram.svg": 2765,
	"./assets/icons/contactlinked.svg": 5992,
	"./assets/icons/contactmail.svg": 3953,
	"./assets/icons/contactphone.svg": 4683,
	"./assets/icons/contacts.svg": 7499,
	"./assets/icons/contactviber.svg": 5087,
	"./assets/icons/contactwebsite.svg": 9845,
	"./assets/icons/contactwhatsapp.svg": 4480,
	"./assets/icons/contactyoutube.svg": 5169,
	"./assets/icons/copy.svg": 121,
	"./assets/icons/copy1.svg": 615,
	"./assets/icons/default3.svg": 9087,
	"./assets/icons/defaultstar.svg": 2080,
	"./assets/icons/defence.svg": 7714,
	"./assets/icons/delete.svg": 9376,
	"./assets/icons/edit.svg": 9235,
	"./assets/icons/elements.svg": 5549,
	"./assets/icons/elements1.svg": 6247,
	"./assets/icons/elements3.svg": 4835,
	"./assets/icons/farm.svg": 2014,
	"./assets/icons/fertilizer.svg": 5160,
	"./assets/icons/file.svg": 9367,
	"./assets/icons/filedocx.svg": 4266,
	"./assets/icons/filepdf.svg": 594,
	"./assets/icons/filter.svg": 1621,
	"./assets/icons/filterclose.svg": 7308,
	"./assets/icons/filteropen.svg": 7343,
	"./assets/icons/fruitapple.svg": 5052,
	"./assets/icons/fruitcarrot.svg": 4226,
	"./assets/icons/fruitcherry.svg": 4171,
	"./assets/icons/fruitcorn.svg": 1338,
	"./assets/icons/fruitother.svg": 5244,
	"./assets/icons/fruitstrawberry.svg": 7643,
	"./assets/icons/fruitwatermelon.svg": 5865,
	"./assets/icons/fruitwheat.svg": 6491,
	"./assets/icons/info.svg": 8520,
	"./assets/icons/info2025.svg": 2892,
	"./assets/icons/key.svg": 5356,
	"./assets/icons/link.svg": 9562,
	"./assets/icons/linkto.svg": 4064,
	"./assets/icons/logo.svg": 5257,
	"./assets/icons/map.svg": 2547,
	"./assets/icons/menu_administration.svg": 7765,
	"./assets/icons/menu_analyses.svg": 1087,
	"./assets/icons/menu_clients.svg": 6335,
	"./assets/icons/menu_defense.svg": 5599,
	"./assets/icons/menu_exit.svg": 5626,
	"./assets/icons/menu_fertilizers.svg": 7850,
	"./assets/icons/menu_glossary.svg": 5577,
	"./assets/icons/menu_invoice.svg": 2952,
	"./assets/icons/menu_products.svg": 1088,
	"./assets/icons/menu_settings.svg": 5441,
	"./assets/icons/password.svg": 4675,
	"./assets/icons/passwordhide.svg": 3883,
	"./assets/icons/passwordshow.svg": 1909,
	"./assets/icons/paste.svg": 914,
	"./assets/icons/paycheck.svg": 8554,
	"./assets/icons/pdffile.svg": 6404,
	"./assets/icons/pesticidebacteria.svg": 6366,
	"./assets/icons/pesticidebug.svg": 299,
	"./assets/icons/pesticidemite.svg": 6095,
	"./assets/icons/pesticidemushroom.svg": 6668,
	"./assets/icons/pesticideother.svg": 2679,
	"./assets/icons/pesticideplant.svg": 5419,
	"./assets/icons/phases_flask.svg": 8591,
	"./assets/icons/phases_flower.svg": 4398,
	"./assets/icons/phases_money.svg": 139,
	"./assets/icons/phases_timetable.svg": 3733,
	"./assets/icons/photo.svg": 4751,
	"./assets/icons/play.svg": 3389,
	"./assets/icons/plus.svg": 2239,
	"./assets/icons/plus2.svg": 1833,
	"./assets/icons/print.svg": 5099,
	"./assets/icons/retry.svg": 6232,
	"./assets/icons/save.svg": 9991,
	"./assets/icons/search.svg": 7341,
	"./assets/icons/settings.svg": 8803,
	"./assets/icons/shuffle.svg": 8971,
	"./assets/icons/stimulator.svg": 138,
	"./assets/icons/tick.svg": 7317,
	"./assets/icons/tick2.svg": 6294,
	"./assets/icons/time.svg": 1274,
	"./assets/icons/user.svg": 8759,
	"./assets/icons/usercompositionmask.svg": 4706,
	"./assets/icons/userdelete.svg": 6890,
	"./assets/icons/waiting.svg": 8381,
	"./assets/icons/warningdiese.svg": 4185,
	"./assets/icons/warningtriangle.svg": 3765,
	"./assets/icons/x.svg": 2826,
	"./assets/images/imageplaceholderaccent.svg": 2245,
	"./assets/images/imageplaceholdergray.svg": 4066,
	"./assets/images/vrediteli/imageplaceholdergray.svg": 3213,
	"./assets/loginpage/checkimg.svg": 727,
	"./assets/loginpage/checkimgaccent.svg": 9607,
	"./assets/loginpage/checkimggray.svg": 964,
	"./assets/loginpage/input-icon_login.svg": 4910,
	"./assets/loginpage/login_logo.svg": 8329,
	"./assets/logo_byparts.svg": 8359,
	"./assets/logo_parts.svg": 7958,
	"./assets/sidemenu/invoice.svg": 6640,
	"./assets/sidemenu/showbtn.svg": 8807,
	"./assets/sidemenu/showbtn_gray.svg": 3407,
	"./assets/sidemenu/sidemenu-exit.svg": 5735,
	"./assets/sidemenu/sidemenu1.svg": 4993,
	"./assets/sidemenu/sidemenu1_white.svg": 9998,
	"./assets/sidemenu/sidemenu2.svg": 5066,
	"./assets/sidemenu/sidemenu2_white.svg": 1170,
	"./assets/sidemenu/sidemenu3.svg": 4562,
	"./assets/sidemenu/sidemenu3_white.svg": 8108,
	"./assets/sidemenu/sidemenu4.svg": 26,
	"./assets/sidemenu/sidemenu4_white.svg": 7522,
	"./assets/sidemenu/sidemenu5.svg": 581,
	"./assets/sidemenu/sidemenu5_white.svg": 9766,
	"./assets/sidemenu/sidemenu6.svg": 7228,
	"./assets/sidemenu/sidemenu6_white.svg": 7235,
	"./assets/sidemenu/sidemenu7.svg": 8478,
	"./assets/sidemenu/sidemenu7_white.svg": 8377,
	"./assets/sidemenu/sidemenu8.svg": 2150,
	"./assets/sidemenu/sidemenu_logo.svg": 7637,
	"./assets/sysmeta/safari-pinned-tab.svg": 2922,
	"./assets/toasticons/toast_cancel-red.svg": 9315,
	"./assets/toasticons/toast_info-grey.svg": 1587,
	"./assets/toasticons/toast_success-green.svg": 934,
	"./assets/toasticons/toast_warning-orange.svg": 389,
	"./assets/toasticons/toast_warning1-orange.svg": 997,
	"./assets/userpanel/img/map_georgia.svg": 3909
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1246;